import { Leaf } from "lucide-react";

export const BiodiversityIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.98633 22.9814C2.9831 22.9833 2.9784 22.9853 2.97266 22.9883C3.00758 22.9003 3.0574 22.7797 3.12109 22.6299C3.27074 22.278 3.50108 21.7643 3.82129 21.1279C4.10742 20.5593 4.46587 19.894 4.90039 19.1582C4.791 19.3936 4.69137 19.6344 4.59766 19.8672C4.3181 20.5617 4.08526 21.2172 3.80176 21.8135C3.51856 22.4091 3.25025 22.7912 2.98633 22.9814ZM22.958 2.97852C22.8764 3.54631 22.7619 4.33413 22.6309 5.21289C22.3682 6.97394 22.0399 9.09113 21.7744 10.543C21.5955 11.5219 20.7572 13.993 18.6338 15.8203C16.5607 17.6043 13.1524 18.8695 7.60742 17.3154H7.60645C7.20473 17.203 6.80861 17.2187 6.44043 17.3662C6.11764 17.4956 5.86051 17.7111 5.65234 17.9443C6.02192 17.3718 6.43 16.7692 6.88379 16.1504C9.73133 12.2675 14.2657 7.69101 21.0283 4.86719L20.6104 3.43555L20.7393 4.1748C20.6102 3.43599 20.6098 3.43547 20.6094 3.43555L20.6084 3.43652H20.6064C20.6044 3.43688 20.6017 3.43792 20.5986 3.43848C20.5924 3.43962 20.5837 3.44039 20.5732 3.44238C20.5521 3.44642 20.5221 3.45308 20.4844 3.46094C20.4089 3.47665 20.3009 3.5005 20.1631 3.53418C19.887 3.60165 19.4907 3.70869 18.9961 3.87012C18.0068 4.19302 16.6217 4.73372 15.0127 5.6084C12.1105 7.18607 8.48385 9.84862 5.13965 14.2734C5.13537 14.1863 5.13093 14.0968 5.12891 14.0049C5.10185 12.7759 5.29339 11.1557 6.15137 9.54395C7.79198 6.46226 12.058 3.09441 22.9648 2.92578C22.9624 2.94311 22.9606 2.96076 22.958 2.97852Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
    // <Leaf strokeWidth={1.5} stroke="var(--color-planet-green)" />
  );
};

export default BiodiversityIcon;
